// import React, { Fragment } from "react";
// import store from "store";
// import { withRouter } from "react-router";
// import { Link } from "react-router-dom";
// var headerInfo = store.get("header");

// class HeaderBot extends React.Component {
//   state = { headerInfo: {} };
//   componentDidMount() {
//     console.log(this.props, "header props");
//     this.setState({ headerInfo: store.get("header") });
//     var self = this;
//     document.addEventListener("headerInfo", function (e) {
//       // Prints "Example of an event"
//       headerInfo = e.detail.headerInfo;
//       console.log({ headerInfo }, "headerInfo");
//       // setheaderInfo(headerInfo);
//       self.setState({ headerInfo });
//     });
//   }
//   render() {
//     const { headerInfo } = this.state;
//     console.log({ headerInfo }, "headerInfo---@@--");
//     // const { brandList, categoryList } = headerInfo;
//     return (
//       <Fragment>
//         <div className="header-bot">
//           <div className="header-bot_inner_wthreeinfo_header_mid">
//             <div className="col-md-4 header-middle">
//               <form>
//                 <input
//                   type="search"
//                   name="search"
//                   placeholder="Search here..."
//                   required=""
//                   onChange={(e) => {
//                     // console.log(e.target.value, "------");
//                     this.props.history.push("/search/" + e.target.value);
//                   }}
//                 />
//                 <input type="button" value=" " />
//                 <div className="clearfix"></div>
//               </form>
//             </div>
//             {/* <!-- header-bot --> */}
//             <div className="col-md-4 logo_agile">
//               <h1>
//                 <Link to="/" style={{ marginTop: 5 }}>
//                   {/* <span>E</span>lite Shoppy */}
//                   <i className="fa fa-ats-logo-icon"></i>
//                   {/* <i
//                     className="fa fa-shopping-bag top_logo_agile_bag"
//                     aria-hidden="true"
//                   ></i> */}
//                 </Link>
//               </h1>
//             </div>
//             {/* <!-- header-bot --> */}
//             <div className="col-md-4 agileits-social top_content">
//               <ul className="social-nav model-3d-0 footer-social w3_agile_social">
//                 <li className="share">Share On : </li>
//                 <li>
//                   <a
//                     href="https://www.facebook.com/Audio-Rental-Audiobot-Store-Trading-100857949429326/?ti=as"
//                     className="facebook"
//                     target="_blank"
//                   >
//                     <div className="front">
//                       <i className="fa fa-facebook" aria-hidden="true"></i>
//                     </div>
//                     <div className="back">
//                       <i className="fa fa-facebook" aria-hidden="true"></i>
//                     </div>
//                   </a>
//                 </li>
//               </ul>
//             </div>
//             <div className="clearfix"></div>
//           </div>
//         </div>
//       </Fragment>
//     );
//   }
// }

// export default withRouter(HeaderBot);


import React, { Fragment, useEffect, useState } from "react";
import store from "store";
import { Link, useNavigate } from "react-router-dom";

const HeaderBot = () => {
  const navigate = useNavigate();
  const [headerInfo, setHeaderInfo] = useState({});
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    // Initial header load
    setHeaderInfo(store.get("header"));

    // Custom event listener
    const handleHeaderInfo = (e) => {
      const info = e.detail.headerInfo;
      setHeaderInfo(info);
    };

    document.addEventListener("headerInfo", handleHeaderInfo);

    // Cleanup (important!)
    return () => {
      document.removeEventListener("headerInfo", handleHeaderInfo);
    };
  }, []);

  useEffect(() => {
    if (!searchInput) return;

    const timer = setTimeout(() => {
      navigate(`/search/${encodeURIComponent(searchInput)}`);
    }, 400);

    return () => clearTimeout(timer);
  }, [searchInput, navigate]);


  return (
    <Fragment>
      <div className="header-bot">
        <div className="header-bot_inner_wthreeinfo_header_mid">
          {/* Search */}
          <div className="col-md-4 header-middle">
            <form onSubmit={(e) => e.preventDefault()}>
              <input
                type="search"
                name="search"
                placeholder="Search here..."
                required
                // onChange={(e) => {
                //   navigate("/search/" + e.target.value);
                // }}
                onChange={(e) => setSearchInput(e.target.value)}
              />
              <input type="button" value=" " />
              <div className="clearfix"></div>
            </form>
          </div>

          {/* Logo */}
          <div className="col-md-4 logo_agile">
            <h1>
              <Link to="/" style={{ marginTop: 5 }}>
                <i className="fa fa-ats-logo-icon"></i>
              </Link>
            </h1>
          </div>

          {/* Social */}
          <div className="col-md-4 agileits-social top_content">
            <ul className="social-nav model-3d-0 footer-social w3_agile_social">
              <li className="share">Share On :</li>
              <li>
                <a
                  href="https://www.facebook.com/Audio-Rental-Audiobot-Store-Trading-100857949429326/?ti=as"
                  className="facebook"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="front">
                    <i className="fa fa-facebook" aria-hidden="true"></i>
                  </div>
                  <div className="back">
                    <i className="fa fa-facebook" aria-hidden="true"></i>
                  </div>
                </a>
              </li>
            </ul>
          </div>

          <div className="clearfix"></div>
        </div>
      </div>
    </Fragment>
  );
};

export default HeaderBot;

